import { useQuery } from '@apollo/client';
import React from 'react';
import * as styles from './HistorySidebar.module.scss';
import PostHistory from './PostHistory';
import IconButton from '../../components/IconButton';
import StickyHeader from '../../components/StickyHeader';
import { AssetTokenProvider } from '../../editor/AssetTokenContext';
import { gql } from '../../graphql/generated/gql';
import closeIcon from '../../icons/non-prefilled/16x16/clear.svg';
import Link from '../../utils/router/Link';
import useNavigate from '../../utils/router/useNavigate';
import postPath from '../../utils/url/postPath';
import CommentHistory from '../comment/CommentHistory';

const POST_QUERY = gql(/** @complexity 2 */ `
  query HistorySidebarPost($id: ID!) {
    post(id: $id) {
      id
      ...postPath_post
      ...CommentHistory_post
    }
    entityAssetToken(entityId: $id, entityType: POST) {
      ...AssetTokenProvider_entityAssetToken
    }
  }
`);

interface HistorySidebarProps {
  postId: string;
  tab: 'comments' | 'versions';
}

const HistorySidebar = ({ postId, tab }: HistorySidebarProps) => {
  const navigate = useNavigate();

  const { data } = useQuery(POST_QUERY, { variables: { id: postId } });

  const post = data?.post;

  if (!post) return null;

  const basePath = postPath(post);

  return (
    <>
      <StickyHeader>
        <div className={styles.tabs}>
          <Link
            activeClassName={styles.active}
            className={styles.tab}
            to={`${basePath}/histories`}
          >
            Versions
          </Link>
          <Link
            activeClassName={styles.active}
            className={styles.tab}
            to={`${basePath}/comments`}
          >
            Comments
          </Link>
          <div className={styles.closeButtonContainer}>
            <IconButton
              applyNegativeMargin
              onClick={() => {
                navigate(basePath);
              }}
              size="large"
              aria-label="Close side panel"
            >
              {closeIcon}
            </IconButton>
          </div>
        </div>
      </StickyHeader>
      <div className={styles.content}>
        <AssetTokenProvider entityAssetToken={data?.entityAssetToken}>
          {tab === 'comments' && <CommentHistory post={post} />}
          {tab === 'versions' && <PostHistory postId={postId} />}
        </AssetTokenProvider>
      </div>
    </>
  );
};

export default HistorySidebar;
